import { render, staticRenderFns } from "./notification-list.vue?vue&type=template&id=06c93c6c&"
import script from "./notification-list.vue?vue&type=script&lang=js&"
export * from "./notification-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports